import FilterTreeController from './filter-tree.controller';

export default function filterTree() {
    return {
        restrict: 'E',
        template: require('./filter-tree.html'),
        controller: FilterTreeController,
        require: '^filterListCtrl',
        controllerAs: 'filterCtrl'
    };
}



// WEBPACK FOOTER //
// ./project/directives/lf-filter-tree/filter-tree.directive.js